import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import router from '@/router/router';

import { SERVER_API_URL } from '@/constants';
import { AuthTokenRefreshResponse } from '@/venit/services/model/techpubs-cms';

const TIMEOUT = 30000;

const onRequestSuccess = (config: InternalAxiosRequestConfig) => {
  const rememberMe = true;
  const token = rememberMe ? localStorage.getItem('techpubs-accessToken') : sessionStorage.getItem('techpubs-accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.timeout = TIMEOUT;
  config.url = `${SERVER_API_URL}${config.url}`;
  return config;
};

const setupAxiosInterceptors = onUnauthenticated => {

  const onResponseError = async error => {
    const status = error.status || error.response.status;

    if (status === 401 && error.response.headers['error-message'] === 'Token expired') {
      // próba odświeżenia tokena i ponowienia operacji
      const rememberMe = true;
      const existingRefreshToken = rememberMe ? localStorage.getItem('techpubs-refreshToken') : sessionStorage.getItem('techpubs-refreshToken');
      if (existingRefreshToken) {
        try {
          const payload = {
            rememberMe: true,
            refreshToken: existingRefreshToken
          };
          const refreshResult: AxiosResponse<AuthTokenRefreshResponse> = await axios.post<AuthTokenRefreshResponse>('/api/auth/refresh-token', payload);

          // zapamiętanie nowych tokenów
          const accessToken = refreshResult.data.accessToken;
          const refreshToken = refreshResult.data.refreshToken;
          storeRefreshToken(refreshToken, rememberMe);
          storeAccessToken(accessToken, rememberMe);

          // mamy zapamietane nowe tokeny - powtorzenie requesta
          if (accessToken) {
            return new Promise((resolve, reject) => {
              axios.request(error.config).then(response => {
                resolve(response);
              }).catch(repatedRequestError => {
                reject(repatedRequestError);
              });
            });
          }
        } catch (_error) {
          return Promise.reject(_error);
        }

      } else {
        // not exists refresh token
        Promise.reject(error);
      }
    } else if (status === 403) {
      const url: string = error.config?.url || '';
      const isAuthRequest = /api\/authentication$/.test(url) || /api\/auth\/login$/.test(url);
      if (!isAuthRequest) {
        router.push('/forbidden').catch(() => {});
        return new Promise(() => {});
      }
      return Promise.reject(error);
    } else {
      // other error
      return Promise.reject(error);
    }
  };

  // wlasciwe ustawienie interceptorow
  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(res => res, onResponseError);
  }
};

function storeRefreshToken(refreshToken, rememberMe) {
  if (refreshToken) {
    if (rememberMe) {
      localStorage.setItem('techpubs-refreshToken', refreshToken);
    } else {
      sessionStorage.setItem('techpubs-refreshToken', refreshToken);
    }
  }
}

function storeAccessToken(accessToken, rememberMe) {
  if (accessToken) {
    if (rememberMe) {
      localStorage.setItem('techpubs-accessToken', accessToken);
    } else {
      sessionStorage.setItem('techpubs-accessToken', accessToken);
    }
  }
}

export { onRequestSuccess, setupAxiosInterceptors };
